import { Injectable } from '@angular/core';
import { HTTP,HTTPResponse } from '@ionic-native/http';
import { ConfigurationManager } from './ConfigurationManager';

@Injectable()
export class ToggleThumbsUpDownService {


    constructor(private http: HTTP, private config: ConfigurationManager) { }

    toggleDealThumbsUpDown(data) {


        const headers = {
            'Content-Type': 'application/json',
            'x-api-key': this.config.environmentConfig.apikey,
            'Accept': 'application/json'
        };


        const body = {
            'DealID': data.DealID + '',
            'ThumbStatus': data.ThumbStatus,
            'SessionID': this.config.getSessionId,
            'ProxyUI': this.config.getProxyUI + '',
            'ClubID': this.config.getClubCode + '',
            'FromNewDNR': 'true',
        };

        console.log('params' + body);
        const url = this.config.environmentConfig.baseurl + 'detbs/v1';
        this.http.setDataSerializer('json');
        return this.http.post(url, body, headers);

    }

}
